// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App.vue'
// @ts-ignore
import router from './router'
// @ts-ignore
import store from './store'
import iView from 'iview'
// @ts-ignore

// import 'iview/dist/styles/iview.css';
// import {Button, Checkbox, Col, Icon, Input, locale, Option, Radio, RadioGroup, Row, Select, Notice, Message, Switch, Modal, Slider} from 'iview'
// @ts-ignore
import ru from 'iview/dist/locale/ru-RU'
// @ts-ignore
import en from 'iview/dist/locale/en-US'
// @ts-ignore
import es from 'iview/dist/locale/es-ES'
// @ts-ignore
import VueQrcode from '@chenfengyuan/vue-qrcode'

import VueClipboard from 'vue-clipboard2'
// @ts-ignore
import VueYandexMetrika from 'vue-yandex-metrika'
// @ts-ignore
import VueAnalytics from 'vue-analytics'
// @ts-ignore
import VueRouterMultiView from 'vue-router-multi-view'
// @ts-ignore
import i18n from './services/i18n.js'

// import style
import 'iview/dist/styles/iview.css'
import '../iview/dist/iview.css'
import './styles/components/iview-overrides.scss'
import './styles/theme.css'

i18n.parseTranslations()

Vue.prototype.$bus = new Vue()

Vue.prototype.$text = i18n

Vue.prototype.$copyToClipboardAndNotify = function (value: string) {
  this.$copyText(value)
  this.$Message.info(this.$text.tr('Cкопировано в буфер'))
}

// import Countly from 'countly-sdk-web'
// import VueCountly from 'vue-countly'

// Vue.use(VueCountly, Countly, {
//   app_key: '3f20294a90e69ecf69c9a4bc02636ac1b7a212b3',
//   url: 'https://countly.daylog.cloud',
//   app_version: process.env.VUE_APP_VERSION,
//   // debug: true,
//   use_session_cookie: false,
//   interval: 5000
// })

Vue.use(VueRouterMultiView)

Vue.use(VueClipboard)

Vue.component(VueQrcode.name, VueQrcode)

// console.log('env:', process.env.NODE_ENV)
// console.log('base_url:', process.env.VUE_APP_BASE_URL)

Vue.use(VueYandexMetrika, {
  id: 52820161,
  router,
  env: process.env.NODE_ENV,
  scriptSrc: 'https://mc.yandex.ru/metrika/tag.js',
  options: {
    clickmap: true,
    trackLinks: true,
    accurateTrackBounce: true
  }
  // other options
})

Vue.use(VueAnalytics, {
  id: 'UA-136525836-2',
  router,
  // autoTracking: {
  //   screenview: true
  // },
  debug: {
    // enabled: true,
    sendHitTask: process.env.NODE_ENV === 'production'
  }
})

// locale(lang)

// Vue.component('Icon', Icon)
// Vue.component('Row', Row)
// Vue.component('Col', Col)
// Vue.component('RadioGroup', RadioGroup)
// Vue.component('Radio', Radio)
// Vue.component('i-input', Input)
// Vue.component('Select', Select)
// Vue.component('Option', Option)
// Vue.component('Button', Button)
// Vue.component('Checkbox', Checkbox)
// Vue.component('Message', Message)
// Vue.component('Notice', Notice)
// Vue.component('Modal', Modal)
// Vue.component('Slider', Slider)
// Vue.component('i-switch', Switch)
let locale = ru
if (store.state.sys.lang === 'en') {
  locale = en
} else if (store.state.sys.lang === 'es') {
  locale = es
}

Vue.use(iView, { locale })

Vue.config.productionTip = false

/* == CUSTOM DIRECTIVES == */
Vue.directive('visible', function (el, binding) {
  el.style.visibility = binding.value ? 'visible' : 'hidden'
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  // @ts-ignore
  router,
  store,
  render: h => h(App)
}).$mount('#app')
